import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"

export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			query.meta?.onError?.(error)
		},
	}),
})

export type ReactQueryProviderProps = {
	children: React.ReactNode
}

export const ReactQueryProvider: React.FC<ReactQueryProviderProps> = ({ children }) => {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default ReactQueryProvider
